import { render, staticRenderFns } from "./DobSplitInput.vue?vue&type=template&id=01d2b808&scoped=true"
import script from "./DobSplitInput.vue?vue&type=script&lang=js"
export * from "./DobSplitInput.vue?vue&type=script&lang=js"
import style0 from "./DobSplitInput.vue?vue&type=style&index=0&id=01d2b808&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2b808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d2b808')) {
      api.createRecord('01d2b808', component.options)
    } else {
      api.reload('01d2b808', component.options)
    }
    module.hot.accept("./DobSplitInput.vue?vue&type=template&id=01d2b808&scoped=true", function () {
      api.rerender('01d2b808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/home/update-missing-dialog/DobSplitInput.vue"
export default component.exports